import React, { useState, useEffect } from 'react';
import { UpDownCaret } from 'Forms/PromoCodeForm/UpDownCaret/UpDownCaret';
import './ExpandableWrapper.css';

export const ExpandableWrapper = ({ emailCoupon, children }) => {
  const [displayPromoForm, setDisplayPromoForm] = useState('collapse');

  useEffect(() => {
    if (emailCoupon) {
      setDisplayPromoForm('expand');
    }
  }, [emailCoupon]);

  const displayToggle = () => {
    setDisplayPromoForm(displayPromoForm === 'collapse' ? 'expand' : 'collapse');
  };

  return (
    <div className="expandableWrapper">
      <div className="titleContainer">
        <button onClick={displayToggle} className="promoCodeFormTitle">
          Have a promo code?
        </button>
        <UpDownCaret handleClick={displayToggle} display={displayPromoForm}></UpDownCaret>
      </div>
      {displayPromoForm === 'expand' && <div className="inputContainer">{children}</div>}
    </div>
  );
};
